import React from 'react';
import { Switch as RNSwitch, SwitchProps as RNSwitchProps } from 'react-native';
import { useTheme } from '@pulsar/core';
import { Platform } from 'src/libs/platform';

export type SwitchProps = RNSwitchProps;

export const Switch: React.FC<SwitchProps> = props => {
  const theme = useTheme();

  return (
    <RNSwitch
      thumbColor={theme.colors.switchThumb}
      trackColor={{
        true: Platform.OS === 'ios' ? theme.colors.switchTrackIOSOn : theme.colors.switchTrackOn,
        false: Platform.OS === 'ios' ? theme.colors.switchTrackIOSOff : theme.colors.switchTrackOff,
      }}
      // @ts-ignore
      activeThumbColor={theme.colors.switchThumbActive}
      {...props}
    />
  );
};
